import { Tag, Icon } from "antd";
import Moment from "react-moment";
import React from "react";

export default (OnUpdateSaleOrder) => [
  {
    title: "Create Date (UTC)",
    dataIndex: "created",
    align: "center",
    render: (text) => {
      return (
        <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm">
          {text}
        </Moment>
      );
    },
  },
  {
    title: "Billing",
    align: "center",
    render: (_, record) => {
      return (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "auto auto",
            gridTemplateRows: "auto auto auto",
            justifyContent: "space-evenly",
            justifyItems: "center",
          }}
        >
          <Tag color="magenta">quotation_no:</Tag>
          <div sty>{record.transaction_ref || "-"}</div>
          <Tag color="magenta">order_no:</Tag>
          <div>{record.order_no || "-"}</div>
          <Tag color="magenta">invoice_no:</Tag>
          <div>{record.invoice_no || "-"}</div>
        </div>
      );
    },
  },
  {
    title: "Country",
    dataIndex: "country_code",
    align: "center",
  },
  {
    title: "User Information",
    dataIndex: "member_id",
    render: (text, record) => {
      let tagKYCStatus;
      if (!record.kyc_logs_detail || !record.kyc_logs_detail.id)
        tagKYCStatus = <Tag color="orange">No KYC</Tag>;

      if (
        record.kyc_logs_detail &&
        record.kyc_logs_detail.status === "resubmit"
      )
        tagKYCStatus = <Tag color="purple">Waiting for new KYC</Tag>;

      return (
        <span>
          <div style={{ marginBottom: "5px" }}>
            <span style={{ fontWeight: "bold", marginRight: "8px" }}>
              {record.email || "-"}
            </span>
          </div>
          <div>
            <Tag color="blue">MBRID: {text}</Tag>
            {tagKYCStatus}
          </div>
        </span>
      );
    },
  },
  {
    title: "Amount",
    dataIndex: "amount",
    align: "center",
    render: (text) => {
      const amount = parseFloat(text);
      const balance = amount.toFixed(4);
      return (
        <div>
          <span>${(balance || 0).toLocaleString()}</span>
        </div>
      );
    },
  },
  {
    title: "Sales Owner",
    dataIndex: "sale_owner",
    align: "center",
    render: (text) => {
      return (
        <span>
          <div style={{ marginBottom: "5px" }}>
            <span style={{ fontWeight: "bold", marginRight: "8px" }}>
              {text.firstname || "-"}
            </span>
          </div>
          <div>{text.email}</div>
        </span>
      );
    },
  },
  {
    title: "Action",
    align: "center",
    render: (record) => {
      return (
        <span
          style={{ cursor: "pointer", color: "cornflowerblue" }}
          onClick={() => OnUpdateSaleOrder(record.id)}
        >
          <Icon type="edit" theme="filled" />
          Update sales order info
        </span>
      );
    },
  },
];



// WEBPACK FOOTER //
// ./src/containers/SaleOrder/column.js